import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'app-view-note',
  templateUrl: './view-note.component.html',
  styleUrls: ['./view-note.component.scss']
})
export class ViewNoteComponent implements OnInit, OnChanges {
  @ViewChild('myDiv', { static: true }) myDivRef!: ElementRef;
  @Input() note: string;
  briefNote: string;
  isShortContent: boolean = false;
  componentWidth: number = 0;
  defaultLength : number = 100;
  ngOnInit(): void {
  
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.note && changes.note.currentValue) {
      this.changeValue(this.defaultLength);
    }
  }
  changeValue(maxLength) {
    const note = this.note || '';
    if (note.length < maxLength) {
      this.isShortContent = true;
    } else {
      this.briefNote = this.note.substring(0, maxLength) + '...';
    }
    setTimeout(() => {
      this.checkUI();
    }, 200)
  }
  checkUI() {
    this.componentWidth = this.myDivRef.nativeElement.offsetWidth;
    if (this.componentWidth < 100) {
      this.changeValue(50);
    }
  }
}
